import { gql } from '@apollo/client'

export const SET_JAPANESE_GROUP = gql`
  mutation SetJapaneseGroup($inputData: SetJapaneseGroupInput!) {
    setJapaneseGroup(inputData: $inputData) {
      id
    }
  }
`
